import Button from "Components/button/button";
import ScrolledDropdown from "Components/scrolledDropdown/scrolledDropdown";
import find from "lodash/find";
import React, { memo, useCallback, useMemo, useState } from "react";
import { playbackRates } from "../utils/constantsPlayer";
const keySelector = (item) => item.value;
const textSelector = (item) => item.icon;
function SpeedTrackSelect(props) {
    const [selectedPlaybackRate, setSelectedPlaybackRate] = useState(1);
    const handleChange = useCallback((newSpeed) => {
        setSelectedPlaybackRate(newSpeed);
        props.handlePlaybackRateChange(newSpeed);
    }, [props.handlePlaybackRateChange]);
    const togglerComponent = useMemo(() => {
        var _a;
        return (React.createElement(Button, { key: selectedPlaybackRate, className: "no-border bg-transparent pt-0 pb-0 btn-with-icon" }, (_a = find(playbackRates, ["value", selectedPlaybackRate])) === null || _a === void 0 ? void 0 : _a.icon));
    }, [selectedPlaybackRate]);
    return (React.createElement(ScrolledDropdown, { items: playbackRates, keySelector: keySelector, textSelector: textSelector, onSelectedChanged: handleChange, selectedKey: selectedPlaybackRate, minWidth: 65, togglerComponent: togglerComponent }));
}
export default memo(SpeedTrackSelect);
